import { isProduction } from "utils";
const { REACT_APP_STRIPE_TEST: testKey, REACT_APP_STRIPE_LIVE: liveKey } =
  process?.env || {};

export default isProduction ? liveKey : testKey;
